import { render } from "./AnimeCabinet.vue?vue&type=template&id=65ba1960&scoped=true"
import script from "./AnimeCabinet.vue?vue&type=script&lang=js"
export * from "./AnimeCabinet.vue?vue&type=script&lang=js"

import "./AnimeCabinet.vue?vue&type=style&index=0&id=65ba1960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba1960"]])

export default __exports__